import React from 'react';

import LoginComponent from './Login/LoginComponent';
import Sidebar from './components/header/sidebar/sidebar.jsx';
import RequiredAuth from './utils/RequiredAuth';
import TerminalAddEdit from './components/body/Terminal/TerminalAddEdit';
import { Navigate } from 'react-router';
import ISOList from './components/body/ISO/ISOList';
import UserList from './components/body/User/UserList';
import ErrorPage from './components/Error/ErrorPage';
import Reports from './components/body/Reports/Reports';
import Import from './components/body/Import/Import';
import TerminalList from './components/body/Terminal/TerminalList';
import MerchantList from './components/body/Merchant/MerchantList';
import MerchantView from './components/body/Merchant/MerchantView';
import MerchantAddEdit from './components/body/Merchant/MerchantAddEdit';
import KeysTable from './components/body/Import/KeysTable';
import ISOView from './components/body/ISO/ISOView';
import ISOAddEdit from './components/body/ISO/ISOAddEdit';
import UserAddEdit from './components/body/User/UserAddEdit';
import UserView from './components/body/User/UserView';
import TerminalProfile from './components/body/Terminal/TerminalProfile';
import EmailVerificationComponent from './EmailVerification/EmailVerificationComponent';
import Dashboard from './components/body/Dashboard/Dashboard';
import LoginAsUser from './components/body/User/LoginAsUser';
import AutoReports from './components/body/Reports/AutoReports';
import ProcessorPrefix from './components/body/Admin/ProcessorPrefix';
import ProcessorTerminalsList from './components/body/ProcessorTerminals/ProcessorTerminalsList';
import ProcessorTerminalProfile from './components/body/ProcessorTerminals/ProcessorTerminalProfile';
import AddEditProcessorConnection from './components/body/ProcessorConnections/AddEditProcessorConnection';
import DisputeList from './components/body/Dispute/DisputeList';
import AddEditProcessorTerminal from './components/body/ProcessorTerminals/AddEditProcessorTerminal';
import SettlementReport from './components/body/Reports/SettlementReport';
import ProcessorReports from './components/body/Reports/ProcessorReports';
import POSClientList from './components/body/POSClient/POSClientList';
import POSClientProfile from './components/body/POSClient/POSClientProfile';
import POSClientAddEdit from './components/body/POSClient/POSClientAddEdit';
import RegisterList from './components/body/Registers/RegisterList';
import RegisterProfile from './components/body/Registers/RegisterProfile';
import AddEditRegister from './components/body/Registers/AddEditRegister';
import BankStatementDescriptor from './components/body/Admin/BankStatementDescriptor';



const routes = [


    {
        path: '/',
        element: <Sidebar />,
        children: [
            { path: '/dashboard', element: <RequiredAuth allowableRoles={["1", "2", "3", "4", "5", "6","7"]}><Dashboard></Dashboard></RequiredAuth> },
            { path: '/', element: <RequiredAuth allowableRoles={["1", "2", "3", "4", "5", "6","7"]}> <Navigate to="/dashboard" /> </RequiredAuth> },
            { path: '/import', element: <RequiredAuth allowableRoles={["1", "6"]}><Import /> </RequiredAuth> },
            { path: '/keys', element: <RequiredAuth allowableRoles={["1", "6"]}><KeysTable /> </RequiredAuth> },
            // { path: '/reports', element: <RequiredAuth allowableRoles={["1","2","3","4","5","6","7"]}><Reports /> </RequiredAuth> },

        ]
    },
    {
        path: '/user',
        element: <Sidebar />,
        children: [

            { path: 'profile', element: <RequiredAuth allowableRoles={["1", "2", "3", "4", "5", "6","7"]}><UserView profile={true} /> </RequiredAuth> },
        ]
    },

    {
        path: '/terminal',
        element: <Sidebar />,
        children: [
            { path: 'list', element: <RequiredAuth allowableRoles={["1", "2", "3", "4", "5", "6","7"]}><TerminalList /> </RequiredAuth> },
            { path: 'view', element: <RequiredAuth allowableRoles={["1", "2", "3", "4", "5", "6","7"]}><TerminalProfile /> </RequiredAuth> },
            { path: 'add', element: <RequiredAuth allowableRoles={["1", "6","7"]}><TerminalAddEdit /> </RequiredAuth> },
            { path: 'edit', element: <RequiredAuth allowableRoles={["1", "6","7"]}><TerminalAddEdit edit={true} /> </RequiredAuth> },

        ]
    },

    {
        path: '/processorTerminal',
        element: <Sidebar />,
        children: [
            { path: 'list', element: <RequiredAuth allowableRoles={["1", "6","7"]}><ProcessorTerminalsList /> </RequiredAuth> },
            { path: 'view', element: <RequiredAuth allowableRoles={["1", "6","7"]}><ProcessorTerminalProfile /> </RequiredAuth> },
            { path: 'add', element: <RequiredAuth allowableRoles={["1", "6","7"]}><AddEditProcessorTerminal /> </RequiredAuth> },
            { path: 'edit', element: <RequiredAuth allowableRoles={["1", "6","7"]}><AddEditProcessorTerminal edit={true} /> </RequiredAuth> },

        ]
    },


    {
        path: '/merchant',
        element: <Sidebar />,
        children: [
            { path: 'list', element: <RequiredAuth allowableRoles={["1", "2", "3", "6","7"]}><MerchantList /> </RequiredAuth> },
            { path: 'view', element: <RequiredAuth allowableRoles={["1", "2", "3", "6","7"]}><MerchantView /> </RequiredAuth> },
            { path: 'add', element: <RequiredAuth allowableRoles={["1", "6","7"]}><MerchantAddEdit /> </RequiredAuth> },
            { path: 'edit', element: <RequiredAuth allowableRoles={["1", "6","7"]}><MerchantAddEdit edit={true} /> </RequiredAuth> },

        ]
    },

    {
        path: '/iso',
        element: <Sidebar />,
        children: [
            { path: 'list', element: <RequiredAuth allowableRoles={["1","6","7"]}><ISOList /> </RequiredAuth> },
            { path: 'view', element: <RequiredAuth allowableRoles={["1", "6","7"]}><ISOView /> </RequiredAuth> },
            { path: 'add', element: <RequiredAuth allowableRoles={["1","7"]}><ISOAddEdit /> </RequiredAuth> },
            { path: 'edit', element: <RequiredAuth allowableRoles={["1","7"]}><ISOAddEdit edit={true} /> </RequiredAuth> },

        ]
    },

    {
        path: '/posClient',
        element: <Sidebar/>,
        children: [
            { path: 'list', element: <RequiredAuth allowableRoles={["1","6","7"]}><POSClientList /> </RequiredAuth> },
            { path: 'view', element: <RequiredAuth allowableRoles={["1", "6","7"]}><POSClientProfile /> </RequiredAuth> },
            { path: 'add', element: <RequiredAuth allowableRoles={["1","6","7"]}><POSClientAddEdit /> </RequiredAuth> },
            { path: 'edit', element: <RequiredAuth allowableRoles={["1","6","7"]}><POSClientAddEdit edit={true} /> </RequiredAuth> },

        ]
    },

    {
        path: '/register',
        element: <Sidebar/>,
        children: [
            { path: 'list', element: <RequiredAuth allowableRoles={["1","6","7"]}><RegisterList /> </RequiredAuth> },
            { path: 'view', element: <RequiredAuth allowableRoles={["1", "6","7"]}><RegisterProfile /> </RequiredAuth> },
            { path: 'add', element: <RequiredAuth allowableRoles={["1","6","7"]}><AddEditRegister /> </RequiredAuth> },
            { path: 'edit', element: <RequiredAuth allowableRoles={["1","6","7"]}><AddEditRegister edit={true} /> </RequiredAuth> },

        ]
    },

    {
        path: '/user',
        element: <Sidebar />,
        children: [
            { path: 'list', element: <RequiredAuth allowableRoles={["1", "6","7"]}><UserList /> </RequiredAuth> },
            { path: 'view', element: <RequiredAuth allowableRoles={["1", "2", "3", "4", "5", "6","7"]}><UserView /> </RequiredAuth> },
            { path: 'add', element: <RequiredAuth allowableRoles={["1", "6","7"]}><UserAddEdit /> </RequiredAuth> },
            { path: 'edit', element: <RequiredAuth allowableRoles={["1", "6","7"]}><UserAddEdit edit={true} /> </RequiredAuth> },

        ]
    },

    {
        path:'/admin',
        element: <Sidebar/>,
        children: [
            { path: 'loginAsUser', element: <RequiredAuth allowableRoles= {["1","6"]}><LoginAsUser/></RequiredAuth>},
            { path: 'autoReports', element: <RequiredAuth allowableRoles= {["1"]}><AutoReports/></RequiredAuth>},
            { path: 'prefixs', element: <RequiredAuth allowableRoles={["1"]}><ProcessorPrefix /> </RequiredAuth> },
            { path: 'connections', element: <RequiredAuth allowableRoles={["1"]}><AddEditProcessorConnection/></RequiredAuth>},
            { path: 'disputes', element: <RequiredAuth allowableRoles={["1","6","7"]}><DisputeList/></RequiredAuth>},
            { path: 'bankStatementDescriptors', element: <RequiredAuth allowableRoles={["1"]}><BankStatementDescriptor/></RequiredAuth>},

        ]
    },

    {
        path:'/reports',
        element: <Sidebar/>,
        children: [
            { path: 'terminal', element: <RequiredAuth allowableRoles= {["1", "2", "3", "4", "5", "6","7"]}><Reports/></RequiredAuth>},
            { path: 'deposit', element: <RequiredAuth allowableRoles= {["1", "2", "3", "4", "5", "6","7"]}><SettlementReport/></RequiredAuth>},
            { path: 'processorTerminal', element: <RequiredAuth allowableRoles={["1"]}><ProcessorReports /> </RequiredAuth> },
        ]
    },

    { path: '/error', element: <ErrorPage /> },

    {path: '/verifyEmail', element: <EmailVerificationComponent/>},


    { path: '/login', element: <LoginComponent /> },

    { path: '*', element: <ErrorPage /> },


];

export default routes;